<template>
  <div style="margin-bottom: 60px; height: auto">
    <div style="margin-top: 40px">
      <div class="nav-content">
        <inside-left v-if="isNav" :left="left"></inside-left>
        <inside-right-vue :right="right"></inside-right-vue>
      </div>
    </div>
  </div>
</template>

<script>
import insideLeft from "./insideLeft.vue";
import insideRightVue from "./insideRight.vue";
export default {
  name: "solution",
  components: {
    insideLeft,
    insideRightVue
  },
  data() {
    return {
      isNav: false,
      navList1: [],
      cmsInfo: {},
      list: [],
      title: "",
      introduce: "",
      left: {},
      right: {}
    };
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.getNav().then(() => {
          //我们希望在这里找出对应id的数组
          let query1 = this.$route.query;
          let item = this.navList1.find(item => item.id === query1.id);
          if (query1.tagnum) {
            //表示含有子列表，我们要请求左列表
            this.isNav = true;
            let infos = {
              state: true,
              rootId: item.id,
              nav: "123",
              num: "other"
            };
            this.cmsInfo = infos;
            this.getNav1().then(() => {
              this.left = {
                list: this.list,
                title: this.title,
                introduce: this.introduce
              };
              //我们在这里获取右侧组件所需要的所有数据并存入right中
              let rightnum = query1.tagnum;
              let zzz = this.list.findIndex((item) => item.ordina == rightnum);
              console.log(zzz,'数组的值');
              // let zzz = (rightnum % 10) - 1;
              this.right = {
                cmsId: this.list[zzz].cmsId,
                title: this.title,
                name: this.list[zzz].title
              };
            });
          } else {
            //表示不含有子列表，我们不用请求子列表
            this.isNav = false;
            this.right = {
              cmsId: item.cmsId,
              title: item.title,
              name: ""
            };
          }
        });
      },
      deep: true
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    this.getNav().then(() => {
      let query1 = this.$route.query;
      let item = this.navList1.find(item => item.id === query1.id);
      if (query1.tagnum) {
        //表示含有子列表，我们要请求左列表
        this.isNav = true;
        let infos = {
          state: true,
          rootId: item.id,
          nav: "123",
          num: "other"
        };
        this.cmsInfo = infos;
        this.getNav1().then(() => {
          this.left = {
            list: this.list,
            title: this.title,
            introduce: this.introduce
          };
          //我们在这里获取右侧组件所需要的所有数据并存入right中
          let rightnum = query1.tagnum;
          let zzz = this.list.findIndex((item) => item.ordina == rightnum);
          console.log(zzz,'数组的值');
          // let zzz = (rightnum % 10) - 1;
          this.right = {
            cmsId: this.list[zzz].cmsId,
            title: this.title,
            name: this.list[zzz].title
          };
        });
      } else {
        //表示不含有子列表，我们不用请求子列表
        this.isNav = false;
        this.right = {
          cmsId: item.cmsId,
          title: item.title,
          name: ""
        };
      }
    });
  },
  methods: {
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    },
    //请求所有的导航的列表，进行初始化，存入到本组件中等待传入左右组件中
    getNav() {
      return new Promise((resolve, reject) => {
        GMS.$http
          .get("/home/getNavigation")
          .then(res => {
            if (res.status == 200) {
              let data = res.data;
              let navList = [];
              for (let i = 0; i < data.length; i++) {
                if (!data[i].parent) {
                  data[i].childList = [];
                  navList.push(data[i]);
                }
              }
              let childList = data.filter(item => {
                return item.parent;
              });
              for (let i = 0; i < navList.length; i++) {
                for (let j = 0; j < childList.length; j++) {
                  if (navList[i].id == childList[j].parent) {
                    navList[i].childList.push(childList[j]);
                  }
                }
              }
              navList.sort(this.sortby("ordina"));
              this.navList1 = JSON.parse(JSON.stringify(navList));
              resolve();
            }
          })
          .catch(error => {
            // this.refreshNav();
            // GMS.vbus.$emit("getId", { inform: 1, guide: 2, workerId: 3 });
            this.$Message.error("获取数据异常", error);
          });
      });
    },
    //我们确定了此处左列表中的选定的item，在这进行预处理对应数组和对应信息，最后赋值到本组件
    //最后判定形成right，传往right组件
    getNav1() {
      return new Promise((resolve, reject) => {
        const info = this.cmsInfo;
        const ind = info.nav;
        const rootId = info.rootId;
        GMS.$http
          .get("/home/getNavigation")
          .then(res => {
            if (res.status != 200) {
              // TODO 给出异常提示
              // this.$Message.error("获取数据异常，请联系管理员");
              return;
            }
            let data = res.data;
            let currentGroup = data.find(el => el.id == rootId);
            if (!currentGroup) {
              this.list = [];
              console.error("未获取到指定的导航分组信息");
              return;
            }
            currentGroup.childList = data.filter(
              item => item.parent == currentGroup.id
            );
            currentGroup.childList.sort(this.sortby("ordina"));
            this.title = currentGroup.title;
            this.list = currentGroup.childList;
            this.introduce = currentGroup.shortName;
            resolve();
          })
          .catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
            console.error(`获取解析导航栏信息异常：${error}`);
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.nav-content {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 1500px) {
  .nav-content {
    width: 1200px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1800px) {
  .nav-content {
    width: 1400px;
  }
}

@media screen and (min-width: 1800px) {
  .nav-content {
    width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inside/solution.vue